export default {
  methods: {
    toHuazhiUrl(urlType,data){
      let url = ''
      let waiwang = window.location.protocol.includes('https')
      let origin = window.location.origin
      switch (urlType) {
        case 'hzbaike': //核百科
            url = 'https://huazhi.cnki.net/qa'
            break;
        case 'hzckllm_islogin':
            url = 'https://huazhi.cnki.net/ckllm/#/chat'
            break;
        case 'hzsw_islogin': //搜问
            url = `${origin}/nz_sw/index`
            break;
        case 'hzzy_islogin': //智研
            url =  `${origin}/zy/`
            break;
        case 'hzmaas': //开放平台
            url = `${origin}/maas/`
            break;
        case 'hzidoc': 
            url = 'https://huazhi.cnki.net/aidoc/'
            break;
        case 'idoc': 
            url = waiwang ? 'https://aidoc.cnki.net/':'http://aidoc.dev.cnki.net/'
            break;
        case 'hzdsi': //CNKI 标准智能问答
            url = 'https://dsi.cnki.net'
            break;
        case 'hzaiplus': //学术研究助手 
            url = 'https://aiplus.cnki.net'
            break;
        case 'invest_islogin': //智能写作充值页面
            url = waiwang ? 'https://aidoc.cnki.net/buyIntegral':'http://aidoc.dev.cnki.net/buyIntegral'
            break;   
      }
      if(!urlType) return this.$message.warning({message:'即将上线，敬请期待',offset:100,duration:1500});
        let link = window.location.href;
        let str = link.split('?')[1] || '';
        let arr = str.split('&');
        let params = {};
        arr.forEach(function(v,k){
            var ar = v.split('=');
            params[ar[0]] = decodeURIComponent(ar[1] || '');
        });
        if(params.realName){
            if(data){
                data.realName = params.realName;
            }else{
                data = {realName: params.realName};
            }
        }
      if(data){
          let para = ['from=henan'];
          for(var k in data){
              para.push(k + '=' + encodeURIComponent(data[k]));
          }
          url += '?' + para.join('&');
      }
      if(!urlType.includes('islogin')) {
          window.open(url, "_blank")
      }else{
         if (this.isLogged) return window.open(url, "_blank")
         else return this.$bus.$emit("needLogin", url);
      }
    }
  },
}